module.exports = __webpack_public_path__ + "img/close-side-menu-black-x.11bb1643.svg";